<template>
  <div
    :class="{
      'h-64': !!isOpen,
      'h-12': !isOpen
    }"
    :style="`background:url(${era.cover}) center -6rem no-repeat;background-size:cover`"
    class="era-container leading-none text-center w-40 flex flex-col justify-end rounded-bl rounded-br overflow-hidden fixed top-0 right-2"
  >
    <span
      :class="{
        'bg-stone-age': eraId === 'stoneAge',
        'bg-bronze-age': eraId === 'bronzeAge',
        'bg-minoan-era': eraId === 'minoanEra',
        'bg-classic-greece': eraId === 'classicGreece',
        'bg-early-rome': eraId === 'earlyRome',
        'bg-roman-empire': eraId === 'romanEmpire',
        'bg-byzantine-era': eraId === 'byzantineEra',
        'bg-age-of-the-franks': eraId === 'ageOfTheFranks',
        'bg-feudal-age': eraId === 'feudalAge',
        'bg-iberian-era': eraId === 'iberianEra',
        'bg-kingdom-of-sicily': eraId === 'kingdomOfSicily',
        'bg-high-middle-ages': eraId === 'highMiddleAges',
        'bg-early-gothic-era': eraId === 'earlyGothicEra',
        'bg-late-gothic-era': eraId === 'lateGothicEra',
      }"
      class="text-white cursor-pointer uppercase h-12 leading-normal px-4 flex flex-col justify-center select-none font-oswald font-extralight"
      @click="toggleOpen"
    >
      {{ era.title }}
    </span>
  </div>
</template>

<script>
import Eras from '@/roc/era';
import {computed, ref, watch} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';

export default {
  setup () {
    const appStore = useApplicationStore();

    const isOpen = ref(true);

    watch(() => appStore.editable, (val) => {
      isOpen.value = !val;
    }, {immediate: true});

    return {
      isOpen,

      eraId: computed(() => {
        return appStore.selectedEra;
      }),

      era: computed(() => {
        return {
          title: Eras[appStore.selectedEra].name,
          cover: require('@/assets/images/era/' + appStore.selectedEra + '.webp')
        };
      }),

      toggleOpen: () => {
        isOpen.value = !isOpen.value;
      }
    };
  }
};
</script>

<style>
.era-container {
  transition: all 200ms ease-in-out;
}
</style>
